import * as React from "react";
import { useEffect, useRef } from "react";
import { sanitize } from "../utils/sanitize";

export default function I18nAction({
  action,
  children,
  className,
}: {
  action: (e: any) => any;
  children: string;
  className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const handler = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.closest(".action")) {
        action(e);
      }
    };

    root.addEventListener("click", handler);

    return () => {
      root.removeEventListener("click", handler);
    };
  }, [action, children]);

  return (
    <span
      ref={ref}
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitize(children) }}
    />
  );
}
